import styled from "styled-components";

export const V3ContentLargeWrapper = styled.div`
    max-width: 1060px;
    margin: 0 auto;
    width: 100%;

    padding-left: 20px;
    padding-right: 20px;
`;